import './SyncEntry.scss';
import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SyncLogs } from './SyncLog';
import { Card, Collapse } from 'antd';
import { CheckCircleOutlined, StopOutlined } from '@ant-design/icons';
import { convertISODateToHumanReadableDate, isSyncCompleted, isSyncFailed, isSyncInProgress, isSyncWaiting } from '@sonar-software/sonar-ts-lib';
export const SyncEntry = ({ onClick, sync }) => {
    const { id, logs, startedOn, status } = sync;
    const humanReadableDate = convertISODateToHumanReadableDate(startedOn);
    const syncCompleted = isSyncCompleted(status);
    const syncFailed = isSyncFailed(status);
    const syncInProgress = isSyncInProgress(status);
    const syncWaiting = isSyncWaiting(status);
    const syncLoading = syncInProgress || syncWaiting;
    const displayStatus = syncLoading ? COPY_GENERIC.IN_PROGRESS : status;
    return (React.createElement(Card, { className: 'sync-entry', key: humanReadableDate, title: humanReadableDate, type: 'inner', variant: 'borderless' },
        React.createElement(Collapse, { items: [{
                    children: React.createElement(SyncLogs, { logs: logs }),
                    key: id,
                    label: COPY_GENERIC.LOG_FOR_SYNC(displayStatus)
                }], onChange: onClick }),
        syncCompleted && React.createElement(CheckCircleOutlined, null),
        syncFailed && React.createElement(StopOutlined, null),
        syncLoading && React.createElement(LoadingSpinner, { size: 'default' })));
};
